import React, { useState } from 'react'
import { Box, IconButton, Stepper, Step, StepButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import StepUploadFile from './updatingSteps/stepUploadFile'
import StepDisplayProducts from './updatingSteps/stepDisplayProducts'
import StepCompareVarconds from './updatingSteps/stepCompareVarconds'

function PricesUpdate({ setIsModalOpen }) {
    const [currentStep, setCurrentStep] = useState(1)
    const [excelData, setExcelData] = useState([])
    const [validatedProducts, setValidatedProducts] = useState([])
    const [errors, setErrors] = useState([])
    const [status, setStatus] = useState('')

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        width: '70%',
        maxHeight: '70%',
        overflow: 'auto',
    }

    const steps = ['Upload File', 'Validate Products', 'Compare & Update']

    const handleFileUpload = (data, errors, status) => {
        setExcelData(data)
        setErrors(errors)
        setStatus(status)
    }

    const handleStepClick = (stepIndex) => {
        if (stepIndex === 0) {
            setCurrentStep(1)
        } else if (stepIndex === 1 && excelData.length > 0) {
            setCurrentStep(2)
        } else if (stepIndex === 2 && validatedProducts.length > 0) {
            setCurrentStep(3)
        }
    }

    const renderCurrentStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <StepUploadFile
                        onFileUpload={handleFileUpload}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        errors={errors}
                        status={status}
                    />
                )
            case 2:
                return (
                    <StepDisplayProducts
                        products={excelData}
                        setValidatedProducts={setValidatedProducts}
                        validatedProducts={validatedProducts}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                    />
                )
            case 3:
                return <StepCompareVarconds validatedProducts={validatedProducts} products={excelData} />
            default:
                return null
        }
    }

    return (
        <Box sx={style}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant='h5' component='h2'>
                    Upload New Prices
                </Typography>
                <IconButton onClick={() => setIsModalOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Stepper activeStep={currentStep - 1} sx={{ mb: 4 }} nonLinear>
                {steps.map((label, index) => (
                    <Step key={index}>
                        <StepButton
                            onClick={() => handleStepClick(index)}
                            disabled={
                                (index === 1 && excelData.length === 0) ||
                                (index === 2 && validatedProducts.length === 0)
                            }>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>

            <Box>{renderCurrentStep()}</Box>
        </Box>
    )
}

export default PricesUpdate
